// 答题游戏相关页面
export default {
  routes: [
    // 答题首页
    {
      path: '/(\\s*)zzAnswerGame(\\d*)/(\\s*)index(\\d*)',
      name: 'zzAnswerGameIndex',
      meta: {
        desc: '答题首页'
      },
      component: () =>
        import(/* webpackChunkName: "zzAnswerGameIndex" */ '../views/zzAnswerGame/index/index.vue')
    },
    // 答题过程
    {
      path: '/zzAnswerGame/gameIng',
      name: 'zzAnswerGameGameIng',
      meta: {
        desc: '答题过程'
      },
      component: () =>
        import(
          /* webpackChunkName: "zzAnswerGameGameIng" */ '../views/zzAnswerGame/gameIng/gameIng.vue'
        )
    },
    //金币商城页面
    {
      path: '/zzAnswerGame/goldStore',
      name: 'zzAnswerGameGoldStore',
      meta: {
        title: '答题赢现金',
        auth: true
      },
      component: () =>
        import(
          /* webpackChunkName: "zzAnswerGameGoldStore" */ '../views/zzAnswerGame/goldStore/Home.vue'
        )
    },
    //答题游戏结果页
    {
      path: '/zzAnswerGame/result',
      name: 'zzAnswerGameResult',
      meta: {
        title: '答题赢现金',
        auth: true
      },
      component: () =>
        import(/* webpackChunkName: "zzAnswerGameResult" */ '../views/zzAnswerGame/result/Home.vue')
    },
    //答题游戏兑换记录页
    {
      path: '/zzAnswerGame/recordList',
      name: 'zzAnswerGameRecordList',
      meta: {
        title: '答题赢现金',
        auth: true
      },
      component: () =>
        import(
          /* webpackChunkName: "zzAnswerGameRecordList" */ '../views/zzAnswerGame/recordList/Home.vue'
        )
    },
    // 前端调试工具
    {
      path: '/(\\s*)zzAnswerGame(\\d*)/(\\s*)debugTool(\\d*)',
      name: 'zzAnswerGameDebugTool',
      meta: {
        title: '答题赢现金',
        auth: true
      },
      component: () =>
        import(
          /* webpackChunkName: "zzAnswerGameDebugTool" */ '../views/zzAnswerGame/DebugTool/debugTool.vue'
        )
    }
  ]
}
